import { useLayoutEffect } from "react";
import { type ApiClientOptions, createApiClient } from "./api-client.ts";
import { createMediaCache } from "./media-cache.ts";

export interface AuthenticatedResourcesOptions {
  accessToken: string;
  maxEntries: number;
  fetchImpl?: ApiClientOptions["fetchImpl"];
}

export function createAuthenticatedResources(options: AuthenticatedResourcesOptions) {
  let accessToken = options.accessToken;
  const api = createApiClient({
    getAccessToken: () => accessToken,
    fetchImpl: options.fetchImpl,
  });
  let shareHandoffConsumption: ReturnType<typeof api.consumeShareHandoff> | null = null;
  const mediaCache = createMediaCache({
    maxEntries: options.maxEntries,
    load: async (path, signal) => await api.mediaBlob(path, signal),
  });

  return {
    api,
    mediaCache,
    consumeShareHandoffOnce() {
      shareHandoffConsumption ??= api.consumeShareHandoff();
      return shareHandoffConsumption;
    },
    useAccessToken(nextAccessToken: string): void {
      useLayoutEffect(() => {
        accessToken = nextAccessToken;
      }, [nextAccessToken]);
    },
  };
}
